import { EnemyType } from "../defines/enums"
import { Beast } from "../defines/types"
import { EnemyDescriptions } from "../defines/values"
import { getEnemyConfig } from "./enemy"

export function getBestiaryConfig(type: EnemyType): Beast | undefined {
  const config = getEnemyConfig(type)

  if (config === undefined) {
    return undefined
  }

  let beast = {
    type: type,
    name: config.name,
    symbol: config.render.symbol[0],
    color: config.render.light,
    description: "",
    seen: false,
    killCount: 0,
  }

  switch (type) {
    case EnemyType.RIFT_ESSENCE:
      beast.description = EnemyDescriptions.RIFT_ESSENCE
      break
    case EnemyType.RIFT_PIGMENT:
      beast.description = EnemyDescriptions.RIFT_PIGMENT
      break
    case EnemyType.RIFT_BOTH:
      beast.description = EnemyDescriptions.RIFT_BOTH
      break

    case EnemyType.VOID_ESSENCE:
      beast.description = EnemyDescriptions.VOID_ESSENCE
      break
    case EnemyType.VOID_PIGMENT:
      beast.description = EnemyDescriptions.VOID_PIGMENT
      break
    case EnemyType.VOID_BOTH:
      beast.description = EnemyDescriptions.VOID_BOTH
      break

    case EnemyType.BLADE_ESSENCE:
      beast.description = EnemyDescriptions.BLADE_ESSENCE
      break
    case EnemyType.BLADE_PIGMENT:
      beast.description = EnemyDescriptions.BLADE_PIGMENT
      break
    case EnemyType.BLADE_BOTH:
      beast.description = EnemyDescriptions.BLADE_BOTH
      break

    case EnemyType.SPECTRE_ESSENCE:
      beast.description = EnemyDescriptions.SPECTRE_ESSENCE
      break
    case EnemyType.SPECTRE_PIGMENT:
      beast.description = EnemyDescriptions.SPECTRE_PIGMENT
      break
    case EnemyType.SPECTRE_BOTH:
      beast.description = EnemyDescriptions.SPECTRE_BOTH
      break

    case EnemyType.REAVER_ESSENCE:
      beast.description = EnemyDescriptions.REAVER_ESSENCE
      break
    case EnemyType.REAVER_PIGMENT:
      beast.description = EnemyDescriptions.REAVER_PIGMENT
      break
    case EnemyType.REAVER_BOTH:
      beast.description = EnemyDescriptions.REAVER_BOTH
      break

    case EnemyType.DEVOURER:
      beast.description = EnemyDescriptions.DEVOURER
      break
  }

  return beast
}
